export default theme => ({
  root: {
    margin: 20,
    width: "100%",
    padding: 20,
  },
});
